const {AITrainingOptOutOrgList, AITrainingOptOutEmailDomains} = require('../constants/duet');

// Where a pre-ticked box isn't valid consent: the EEA (and its territories), UK and Switzerland
const NoPreCheckCountries = new Set([
  'AT', 'BE', 'BG', 'CY', 'CZ', 'DE', 'DK', 'EE', 'ES', 'FI', 'FR', 'GR', 'HR', 'HU',
  'IE', 'IT', 'LT', 'LU', 'LV', 'MT', 'NL', 'PL', 'PT', 'RO', 'SE', 'SI', 'SK',
  'AX', 'GF', 'GP', 'MF', 'MQ', 'RE', 'YT', 'IS', 'LI', 'NO',
  'GB', 'GG', 'GI', 'IM', 'JE', 'CH',
]);

// Opted out of AI training, via org SSO membership or a denylisted email domain
const isAITrainingOptOut = (user) => Boolean(user) && (
  Boolean(AITrainingOptOutOrgList[user.sso_provider])
  || AITrainingOptOutEmailDomains.includes(String(user.email || '').split('@')[1]?.toLowerCase())
);

// Recording features are limited to US-located users, to cap Twilio costs
const isUSLocated = (user) => String(user?.data?.country || '').toUpperCase() === 'US';

// Whether the user agreed to contribute recordings (never true when opted out of AI training)
const hasRecordingConsent = (user) => (
  Boolean(user) && isUSLocated(user) && !isAITrainingOptOut(user)
  && user.data?.allow_recording_consent === true
);

// Whether the user may be offered the opt-in: never for org users and members
const canGiveRecordingConsent = (user) => (
  Boolean(user) && isUSLocated(user) && !user.org && !isAITrainingOptOut(user)
);

// Whether to pre-tick: the user can opt in, hasn't chosen, and is in a known allowed country
const canPreCheckRecordingConsent = (user) => {
  if (!canGiveRecordingConsent(user)) return false;
  if (typeof user.data?.allow_recording_consent === 'boolean') return false;
  const country = user.data?.country;
  return Boolean(country) && !NoPreCheckCountries.has(String(country).toUpperCase());
};

module.exports = {
  isUSLocated,
  isAITrainingOptOut,
  hasRecordingConsent,
  canGiveRecordingConsent,
  canPreCheckRecordingConsent,
};
